import React from 'react';

const Footer = () => {
  return (
    <footer id="portfolio-footer">
      <div className="footer-inner">
        <p>&copy; {new Date().getFullYear()} Laur-Alexandru Cristea — built with React.</p>
        <nav aria-label="Footer navigation" className="footer-links">
          <a href="https://github.com/AlexandruCL" target="_blank" rel="noopener noreferrer">GitHub</a>
          <a href="https://www.linkedin.com/in/laur-alexandru-cristea-24b867312/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="mailto:alex.cristea.laur2004@gmail.com">Email</a>
          <a href="#home">Back to top ↑</a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
